import React from 'react';

import Data from './Data';

const HeadlineSidebar = (props) => {
  return <Data {...props} />;
};

export default HeadlineSidebar;
